import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const actions = [
    {
      id: 1,
      title: 'Nouveau Partenaire',
      description: 'Ajouter un partenaire manuellement',
      icon: 'UserPlus',
      color: 'bg-success/10 text-success border-success/20',
      action: () => console.log('Add partner')
    },
    {
      id: 2,
      title: 'Créer Campagne',
      description: 'Lancer une nouvelle campagne',
      icon: 'Plus',
      color: 'bg-accent/10 text-accent border-accent/20',
      action: () => console.log('Create campaign')
    },
    {
      id: 3,
      title: 'Traiter Paiements',
      description: 'Approuver les paiements en attente',
      icon: 'CreditCard',
      color: 'bg-warning/10 text-warning border-warning/20',
      action: () => console.log('Process payments')
    },
    {
      id: 4,
      title: 'Rapport Mensuel',
      description: 'Générer le rapport du mois',
      icon: 'FileText',
      color: 'bg-primary/10 text-primary border-primary/20',
      action: () => console.log('Generate report')
    },
    {
      id: 5,
      title: 'Configuration',
      description: 'Paramètres système',
      icon: 'Settings',
      color: 'bg-muted text-muted-foreground border-border',
      action: () => console.log('Open settings')
    },
    {
      id: 6,
      title: 'Support',
      description: 'Centre d\'aide et tickets',
      icon: 'HelpCircle',
      color: 'bg-error/10 text-error border-error/20',
      action: () => console.log('Open support')
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-card-foreground mb-1">Actions Rapides</h3>
        <p className="text-sm text-muted-foreground">Raccourcis vers les fonctions principales</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {actions?.map((action) => (
          <button
            key={action?.id}
            onClick={action?.action}
            className={`p-4 rounded-lg border transition-all duration-200 hover:shadow-md hover:scale-105 text-left ${action?.color}`}
          >
            <div className="flex items-center space-x-3 mb-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-current/10">
                <Icon name={action?.icon} size={20} />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-sm">{action?.title}</h4>
              </div>
            </div>
            <p className="text-xs opacity-80 leading-relaxed">{action?.description}</p>
          </button>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex flex-col sm:flex-row gap-3">
          <Button variant="outline" fullWidth>
            <Icon name="Download" size={16} className="mr-2" />
            Exporter Données
          </Button>
          <Button variant="default" fullWidth>
            <Icon name="BarChart3" size={16} className="mr-2" />
            Rapport Complet
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;